// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal-module__modal___17SXF"};